import PageHeader from "../components/PageHeader";
import Contact from "../components/Contact";
import Partners from "../components/Partners";
import { useLang } from "../i18n/LanguageContext";

export default function ContactPage() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        overline={t("pages.contactOverline")}
        title={<>{t("pages.contactTitlePre")} <span className="italic text-[#1E3A5F]">{t("pages.contactTitleItalic")}</span>.</>}
        subtitle={t("pages.contactSubtitle")}
      />
      <Contact />
      <Partners />
    </>
  );
}
